import { PatientMedicationsConstants } from '../store/patientMedications.constants'

export const patientMedicationSchemas = [
  {
    inputKey: PatientMedicationsConstants.SET_NAME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_NAME: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,100}$',
      },
    },
    additionalProperties: false,
    required: ['SET_NAME'],
    errorMessage: {
      properties: {
        SET_NAME: 'Must be alphanumeric with max length of 100',
      },
    },
  },
  {
    inputKey: PatientMedicationsConstants.SET_DOSE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_DOSE: {
        type: 'number',
        minimum: 0.1,
        maximum: 999999.999,
      },
    },
    additionalProperties: false,
    required: ['SET_DOSE'],
  },
]
